<template>
<div class="footer">
    <div class="fnav"><a href="/">{{ $t('layout2.PublicLayoutFooter.259577-0') }}</a>|<a href="/notice/bid-notice">{{ $t('layout2.PublicLayoutFooter.259577-1') }}</a>|<a href="/notice/bid-winning-notice" >{{ $t('layout2.PublicLayoutFooter.259577-2') }}</a>|<a href="/notice/supplier-requirement" >{{ $t('layout2.PublicLayoutFooter.259577-3') }}</a>|<a href="/service-center/index" >{{ $t('layout2.PublicLayoutFooter.259577-4') }}</a></div>
    <div class="finfo"></div>
    <div class="finfo">{{ $t('layout2.PublicLayoutFooter.259577-5') }}</div>
</div>

</template>

<script>
import ResizeMixin from '@/framework/layout/mixin/ResizeHandler'
import { mapState } from 'vuex'

export default {
  name: 'PublicLayoutFooter',
  components: {},
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      noticeNumber: state => state.app.noticeNumber,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  @import "~@/framework/styles/mixin.scss";
  @import "~@/config/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }

    .hamburger-container {
      line-height: $tabsHeight;
      height: 100%;
      float: left;
      cursor: pointer;
      transition: background .3s;
      -webkit-tap-highlight-color:transparent;
      border-width: 0px;

      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }
    .app-main-scroll-container {
      height: calc(100vh - #{$tabsHeight} - #{$headerHeight});
      width: 100%;
      .scrollbar {
        height: 100%;
        .scrollbar-wrapper {
          overflow-x: hidden;
        }
      }
    }
    .footer {
      height: $footerHeight;
      background: $footerBackgroundColor;
      color: $footerFontColor;
      font-size: $footerFontSize;
      text-align: $footerAlign;
      width: 100%;
      line-height: $footerHeight;
      border-top: 1px solid $footerBorderColor;
    }
  }



  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
